import styled from 'styled-components'

import { Avatar } from '@blade/ui-kit'
import { DomUtil } from '@root/shared'
import { ImagePopover } from '@root/shared/ui'

import {
  HeadingExternalLink,
  HeadingName,
  HeadingUsername,
} from './explore-dev-twitter-tooltip-heading'

import type { TwitterSocialProfile } from '@root/entities/socials/model/socials'

export type ExploreDevTwitterTooltipProps = {
  twitterInfo: TwitterSocialProfile & { profileBannerUrl: string }
}

export const ExploreDevTwitterTooltipHeadingBanner = ({
  twitterInfo,
}: ExploreDevTwitterTooltipProps) => {
  return (
    <Root>
      <Banner
        style={{
          backgroundImage: DomUtil.cssUrl(twitterInfo.profileBannerUrl),
        }}
      />
      <Content>
        <Top data-has-avatar={Boolean(twitterInfo.profileImageUrl).toString()}>
          {twitterInfo.profileImageUrl ? (
            <AvatarWrapper>
              <ImagePopover src={twitterInfo.profileImageUrl} alt="username">
                <Avatar
                  src={twitterInfo.profileImageUrl}
                  alt="username"
                  size={48}
                />
              </ImagePopover>
            </AvatarWrapper>
          ) : undefined}
          <Link>
            <HeadingExternalLink url={twitterInfo.url} />
          </Link>
        </Top>
        <Bottom>
          <HeadingName
            username={twitterInfo.username}
            name={twitterInfo.name}
            verified={twitterInfo.verified}
          />
          <HeadingUsername
            username={twitterInfo.username}
            createdAt={twitterInfo.createdAt}
          />
        </Bottom>
      </Content>
    </Root>
  )
}

const Root = styled.div``
const Banner = styled.div`
  border-radius: 6px 6px 0 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;

  height: 100px;
`
const Top = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 8px;

  &[data-has-avatar='true'] {
    margin-top: -31px;
  }
`
const Link = styled.div`
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;
`
const Bottom = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 8px;
`
const AvatarWrapper = styled.div`
  width: fit-content;
  display: flex;
  border-radius: 50%;
  padding: 2px;
  background: var(--background-2);
`
